import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { applepay as ApplePayApi } from "@teem/constants/api";

@Injectable({
  providedIn: 'root'
})
export class ApplePayService {
  constructor(
    private httpClient: HttpClient
  ) { }

  public validateMerchantSession(validationUrl: string) {
    return new Promise(function (resolve, reject) {
      const xmlReq = new XMLHttpRequest();
      xmlReq.open("POST", ApplePayApi.verifyMerchant);
      xmlReq.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(JSON.parse(xmlReq.response));
        } else {
          reject({
            status: this.status,
            statusText: xmlReq.statusText
          });
        }
      };

      xmlReq.onerror = function () {
        reject({
          status: this.status,
          statusText: xmlReq.statusText
        });
      };

      xmlReq.setRequestHeader("Content-Type", "application/json");
      xmlReq.setRequestHeader("Authorization", `Bearer ${(window as any).userInfo.api_token}`);
      xmlReq.send(JSON.stringify({ validationUrl: validationUrl }));
    });
  }

  public authorizePayment(uuid: string, params: any) {
    return new Promise(function (resolve, reject) {
      const xmlReq = new XMLHttpRequest();
      xmlReq.open("POST", ApplePayApi.authorizePayment(uuid));
      xmlReq.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xmlReq.response);
        } else {
          reject({
            status: this.status,
            statusText: xmlReq.statusText
          });
        }
      };
      xmlReq.onerror = function () {
        reject({
          status: this.status,
          statusText: xmlReq.statusText
        });
      };
      xmlReq.setRequestHeader("Content-Type", "application/json");
      xmlReq.setRequestHeader("Authorization", `Bearer ${(window as any).userInfo.api_token}`);
      xmlReq.send(JSON.stringify(params));
    });
  };

  public finalAmount(params: any) {
    console.log(ApplePayApi.calculate_amount);
    return this.httpClient.post(`${ApplePayApi.calculate_amount}`, params);
  }

}
